import React from "react"

import { ImageHand } from "../components/gatsby-image/hand-images"
import Svg from "../components/gatsby-image/svg"

const Section = ({
  bgColor,
  heading,
  textColor,
  columnPlacement,
  secondaryIdeas,
  src,
  description,
  microheading,
  microheadingColor,
  children,
}) => {
  return (
    <>
      <div className="section-cnt" style={{ color: `${textColor}` }}>
        <div className="color-bg" style={{ backgroundColor: `${bgColor}` }} />
        <div className="section margin">
          <div className="section-grid">
            <div className={`cont-cnt column-${columnPlacement}`}>
              <div className="content">
                <p style={{ color: `${microheadingColor}` }}>
                  <strong>{microheading}</strong>
                </p>
                <h2>{heading}</h2>
                <p className="sub-heading description">{description}</p>
                {children}
                <div className="card-grid small">
                  <SecondPoints secondaryIdeas={secondaryIdeas} />
                </div>
              </div>
            </div>
            <div className="image-cnt">
              <div className="image">
                <ImageHand src={src} className={src} />
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  )
}
export default Section

const SecondPoints = ({ secondaryIdeas }) => {
  return (
    <>
      {secondaryIdeas.map(({ heading, bodyText, icon }) => (
        <Card bodyText={bodyText} heading={heading} icon={icon} />
      ))}
    </>
  )
}

const Card = ({ heading, bodyText, icon }) => {
  function createMarkup() {
    return { __html: bodyText }
  }
  return (
    <div className="card">
      <Svg svg={icon} />
      <h4>{heading}</h4>
      <div dangerouslySetInnerHTML={createMarkup()} />
    </div>
  )
}
